import {
    ConditionType,
    ConditionType_IsNull,
    ConditionType_NotNull,
    ConditionType_NumberBetween,
    ConditionType_NumberEquals,
    ConditionType_NumberGreaterThan,
    ConditionType_NumberLessThan
} from "../../model2/conditions/condition-types"
import Filter from "../../manager/filters/manager/filter"
import EstimateAllocateUtils from "../../gd/utils/estimate-allocate-utils"

export const FIELD_CONDITIONS_NUMBER     = [
    ConditionType_NumberGreaterThan,
    ConditionType_NumberLessThan,
    ConditionType_NumberEquals,
    ConditionType_NumberBetween,
    ConditionType_IsNull,
    ConditionType_NotNull,
]

// const debugNumber = 'FieldNumber_filterFunc'
const debugNumber = false

export function FieldNumber_filterFunc(filter: Filter, model:any): boolean {
    if (!filter.type) return true

    let fieldValue: number = _.get(model, filter.field?.fieldId!, 0)

    debugNumber && console.log(debugNumber, 'process', filter.type, filter.value, fieldValue)

    return _filterFunc(filter.type, filter.value, fieldValue)
}

export function FieldNumber_hours_filterFunc(filter: Filter, model:any): boolean {
    if (!filter.type) return true

    const fieldValue: number = _.get(model, filter.field?.fieldId!, 0)

    const hours = EstimateAllocateUtils.minutesToHours(fieldValue)

    return _filterFunc(filter.type, filter.value, hours)
}

function _filterFunc(type: ConditionType, value: any, fieldValueNumber: number) {
    switch (type) {
        case ConditionType.IS_NULL:
            return _.isNil(fieldValueNumber)

        case ConditionType.NOT_NULL:
            return !_.isNil(fieldValueNumber)

        case ConditionType.NUMBER_EQUALS:
            return _.isNil(value) ||
                fieldValueNumber === _.toNumber(value)

        case ConditionType.NUMBER_LESS_THAN:
            return _.isNil(value) ||
                fieldValueNumber < _.toNumber(value)

        case ConditionType.NUMBER_GREATER_THAN:
            return _.isNil(value) ||
                fieldValueNumber > _.toNumber(value)

        case ConditionType.NUMBER_BETWEEN:
            return _.isEmpty(value.greaterThan) ||
                _.isEmpty(value.lessThan) ||
                (_.toNumber(value.greaterThan) <= fieldValueNumber && fieldValueNumber <= _.toNumber(value.lessThan))
        default:
            return false
    }
}